import type { PDPLayoutSlot as PDPLayoutSchema } from '@amplience/content-types/typings/s-pdp-layout';
import { CMS_SLOTS_DELIVERY_KEYS, CmsSlot, isServer } from '@storefront/lib-global';
import type { CarouselProduct, GiftCardProduct, Product } from '@storefront/lib-global/codegen/types';
import type { HandlebarTemplateProps } from '@storefront/lib-global/globalComponents/handlebarTemplate/HandlebarTemplate';
import { useMediaMatch } from '@storefront/lib-global/hooks/useMediaMatch';
import { media } from '@storefront/lib-global/stylings';
import { getSupportedGiftCardType } from '../../utils/giftCard';
import GiftCardDetail from './giftCardDetail/GiftCardDetail';
import ProductDetail from './productDetail/ProductDetail';

export type PDPLayoutProps = {
  pdpLayout: PDPLayoutSchema;
  product: Product;
  giftCard?: GiftCardProduct;
  carouselData: { deliveryId: string; carouselProducts: CarouselProduct[] }[];
  handlebarComponents: HandlebarTemplateProps[] | null;
  locale?: string;
  isServerDesktop?: boolean;
};

export function PDPLayout({
  pdpLayout,
  product,
  carouselData,
  giftCard,
  handlebarComponents,
  locale,
  isServerDesktop,
}: PDPLayoutProps) {
  const isDesktop = useMediaMatch(media.greaterThan('lg'), isServerDesktop);
  const shouldShowDesktopH1 = isServer() ? isServerDesktop : isDesktop;
  const shouldShowMobileH1 = isServer() ? !isServerDesktop : !isDesktop;

  return (
    <>
      <CmsSlot deliveryKey={CMS_SLOTS_DELIVERY_KEYS.PDP_TOP_BANNER} />
      {giftCard ? (
        <GiftCardDetail
          carouselData={carouselData}
          giftCard={giftCard}
          pdpLayout={pdpLayout}
          handlebarComponents={handlebarComponents}
          supportedTypes={getSupportedGiftCardType(locale)}
          shouldShowDesktopH1={shouldShowDesktopH1}
          shouldShowMobileH1={shouldShowMobileH1}
        />
      ) : (
        <ProductDetail
          product={product}
          pdpLayout={pdpLayout}
          carouselData={carouselData}
          handlebarComponents={handlebarComponents}
          shouldShowDesktopH1={shouldShowDesktopH1}
          shouldShowMobileH1={shouldShowMobileH1}
        />
      )}
    </>
  );
}
